'use client';

import { useEffect } from 'react';

// Replaces the root layout when it crashes, so it must render its own <html>/<body>
// and can't rely on globals.scss, fonts or Tailwind.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          boxSizing: 'border-box',
          background: 'linear-gradient(180deg, #F7F3EE 0%, #ffffff 60%)',
          fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
          color: '#111827',
          textAlign: 'center',
        }}
      >
        <main style={{ maxWidth: 480 }}>
          <p style={{ fontSize: 22, fontWeight: 800, color: '#06233F', margin: '0 0 24px' }}>LovingEcards</p>
          <h1 style={{ fontSize: 30, fontWeight: 600, margin: '0 0 12px' }}>Something went wrong</h1>
          <p style={{ fontSize: 16, lineHeight: 1.6, color: '#4b5563', margin: '0 0 28px' }}>
            Sorry, we hit an unexpected problem. Your cards and messages are safe. Please try again.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={() => reset()}
              style={{
                padding: '12px 28px',
                borderRadius: 999,
                border: 'none',
                background: '#06233F',
                color: '#ffffff',
                fontSize: 16,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Try again
            </button>
            {/* Plain <a>: a full reload is intended after the root layout crashed. */}
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
            <a
              href="/"
              style={{
                padding: '12px 28px',
                borderRadius: 999,
                border: '1px solid #e5e7eb',
                background: '#ffffff',
                color: '#1f2937',
                fontSize: 16,
                fontWeight: 600,
                textDecoration: 'none',
              }}
            >
              Go to homepage
            </a>
          </div>
        </main>
      </body>
    </html>
  );
}
